import React from 'react';
import { StyleSheet, Text, View} from 'react-native'

// View
export default function Friends({navigation}) {
	return (
		<View style={styles.container}>
			<Text>  </Text>
		</View>
	)
}

// Styles
const styles = StyleSheet.create({
	container: {
		flex: 1,
		alignItems: 'center',
		justifyContent: 'center',
		backgroundColor:'black'
	},
});
